import type { OfferHelpers } from './types';

export function useOfferHelpers(): OfferHelpers {
  return {};
}
